<template>
  <v-card
    color="#f1f2f3"
    v-show="(!activeDrawer && isSmAndDown) || !isSmAndDown"
  >
    <v-flex xs12>
      <v-layout class="seat-header">
        <v-flex xs12 md8 class="px-4 pt-3">
          <v-btn fab flat class="mr-4 recenter-btn" @click="resetZoom">
            <!-- <v-img
              flat
              src="https://blueticket-cdn.s3.amazonaws.com/assets/icons/re-center.svg"
            ></v-img> -->
          </v-btn>

          <v-btn
            class="add-remove-button"
            @click="onZoomIn"
            outline
            small
            fab
            color="secondary"
          >
            <v-icon class="add-remove-button__icon">add</v-icon>
          </v-btn>

          <v-btn
            class="add-remove-button mx-4"
            @click="onZoomOut"
            outline
            small
            fab
            color="secondary"
          >
            <v-icon class="add-remove-button__icon">remove</v-icon>
          </v-btn>

          <span
            :class="isSmAndDown ? 'seat-header-text-mb' : 'seat-header-text'"
            v-if="!activeDrawer"
            >Use o zoom para aproximar</span
          >
        </v-flex>
        <v-spacer></v-spacer>
        <v-flex shrink class="px-4 pt-3" v-if="!isSmAndDown" @click="openInfo">
          <v-btn
            class="add-remove-button mr-4"
            v-if="!activeDrawer"
            outline
            small
            fab
            color="secondary"
          >
            <span class="secondary--text">?</span>
          </v-btn>
          <span
            class="seat-header-subtitle-text click-btn"
            v-if="!activeDrawer"
            @click="openInfo"
            >Legenda</span
          >
        </v-flex>
      </v-layout>
    </v-flex>
    <!-- <v-divider></v-divider> -->
    <panZoom
      v-if="sectorMap && sectorMap.length > 1"
      id="panz"
      @init="onInit"
      :style="{
        overflow: 'hidden',
        outline: 'none !important',
        cursor: 'move',
        backgroundColor: mapBgColor,
      }"
      :options="{
        minZoom: isSmAndDown ? 0.4 : 0.7,
        maxZoom: 4,
        touchEnabled: true,
        zoomSpeed: !isSmAndDown ? 0.195 : 0.04,
        pinchSpeed: 1,
        zoomDoubleClickSpeed: 1,
        bounds: false,
      }"
    >
      <div id="seatmap" class="noselect">
        <v-tooltip
          top
          v-for="seat in formattedMap"
          :key="seat.codigo_obj"
          color="#192B46"
          :disabled="!seat.codigo_assento"
        >
          <span
            :id="seat.codigo_obj"
            slot="activator"
            :class="checkObjectClass(seat)"
            :style="validateStyle(seat)"
            style="display: flex; justify-content: center; align-items: center"
            v-touch="
              seat.identificacao &&
              seat.disponivel &&
              !(seat.tipo === '9' && !seat.produto_vinculado)
                ? setSeatToSelect
                : handleShowError
            "
          >
            <div
              :id="seat.codigo_obj"
              :class="
                seat.identificacao &&
                (seat.identificacao.includes('mesa') ||
                  seat.identificacao.includes('MESA'))
                  ? 'table-number'
                  : 'seat-number'
              "
              v-if="
                seat.identificacao &&
                  seat.class !== 'cadeiraDefici2' &&
                  seat.class !== 'cadeiraDefici1' &&
                  !seat.selecionado
              "
              :style="
                `
                ${seat.class === 'espaco' ? 'font-size: 20px !important;' : ''}
                ${seat.class === 'mesa' ? 'color: #FFFFFF;' : ''}
              `
              "
            >
              {{ getIdentification(seat) }}
            </div>
            <div
              :id="seat.codigo_obj"
              class="seat-number"
              v-if="seat.selecionado"
            >
              <v-icon small color="#192b46" class="selecting">check</v-icon>
            </div>
            <div
              class="identificacao"
              v-if="
                seat.class === 'elementoIdent' &&
                  seat.descricao !== 'Indisponível'
              "
              v-html="seat.descricao"
            ></div>

            <div class="identificacao" v-if="seat.class === 'icon'">
              <i
                :class="seat.descricao"
                :style="
                  `
                    color: ${getSpecificStyle(seat.style, 'color')};
                    font-size: ${getSpecificStyle(seat.style, 'font-size')}px; 
                    transform: ${getSpecificStyle(seat.style, 'transform')};`
                "
              ></i>
            </div>

            <!-- MIDPOINT TO TEST -->
            <!-- <div class="identificacao" v-if="seat.class === 'midpoint'">
              <i
                class="fa-regular fa-pencil"
                :style="
                  `
                    color: 'red';
                    font-size: 20px; 
                   `
                "
              ></i>
            </div> -->

            <div
              v-if="
                seat.descricao &&
                  seat.class !== 'icon' &&
                  seat.class !== 'elementoIdent' &&
                  seat.descricao !== 'Indisponível' &&
                  seat.tipo !== '9'
              "
              class="seat-number"
              :style="
                `${
                  getSpecificStyle(seat.style, 'color')
                    ? `color: ${getSpecificStyle(
                        seat.style,
                        'color'
                      )} !important; `
                    : ''
                }${
                  getSpecificStyle(seat.style, 'font-size')
                    ? `font-size: ${getSpecificStyle(
                        seat.style,
                        'font-size'
                      )} !important; `
                    : ''
                }`
              "
              :class="
                seat.descricao === 'palco' ? 'palco ident-palco' : 'ident-palco'
              "
            >
              <div
                v-if="!seat.descricao.includes('</')"
                :style="{
                  transform:
                    getSpecificStyle(seat.style, 'label-text-rotation') || '',
                  color: getSpecificStyle(seat.style, 'color') || '',
                }"
              >
                {{ seat.descricao }}
              </div>
              <div v-else v-html="seat.descricao"></div>
            </div>
            <div
              :id="seat.codigo_obj"
              class="seat-number"
              v-if="
                (seat.class === 'cadeiraDefici2' ||
                  seat.class === 'cadeiraDefici1') &&
                  !seat.selecionado
              "
            >
              <v-icon class="seat-cadeirante selecting">accessible</v-icon>
            </div>
          </span>
          <div>
            <span v-if="seat.class === 'mesa'" class="tooltip-text-title">
              {{ MIXIN_AUX_getTableTooltipInfo(seat.identificacao) }}
            </span>
            <span
              v-else-if="
                seat.class !== 'mesa' &&
                  seat.identificacao &&
                  String(seat.identificacao).includes('Mesa')
              "
              class="tooltip-text-title"
            >
              {{ MIXIN_AUX_getChairInfoFromTable(seat.identificacao) }}
            </span>

            <span
              v-else-if="
                seat.class !== 'mesa' &&
                  seat.identificacao &&
                  String(seat.identificacao).includes('MESA')
              "
              class="tooltip-text-title"
            >
              {{ MIXIN_AUX_getChairInfoFromTable(seat.identificacao) }}
            </span>

            <span v-else class="tooltip-text-title"
              >{{ seat.identificacao | getRow }}
              {{ seat.identificacao | getNumber }}
            </span>

            <br />
            <span class="tooltip-text" v-if="!seat.disponivel">
              Indisponível
            </span>

            <span
              class="tooltip-text"
              v-if="seat.disponivel && seat.tipo !== '9'"
              >{{ seat.nome_produto_vinculado }}
            </span>
            <br v-if="seat.tipo !== '9'" />
            <span class="tooltip-text" v-if="seat.disponivel">
              {{ seat.tipo === '9' ? 'Total: ' : '' }}
              {{ showPriceRange(seat) }}
            </span>
          </div>
          <div
            v-if="
              seat.disponivel &&
                seat.produto_vinculado &&
                getProductDetails(seat) &&
                getProductDetails(seat).valor_consumacao_lote
            "
          >
            <span class="tooltip-text">
              Consumação:
              {{
                (getProductDetails(seat).valor_consumacao_lote * 100) | currency
              }}
            </span>
          </div>
          <div
            v-if="
              seat.disponivel &&
                seat.produto_vinculado &&
                getProductDetails(seat)
            "
          >
            <span class="tooltip-text">
              {{ getProductDetails(seat).observacoes }}
            </span>
          </div>
        </v-tooltip>
      </div>
    </panZoom>
    <div v-else>Indisponível</div>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex';
import { getTableInfo } from '../../mixins/getTableInfo';
// const seatdata = require('@/data.json');

export default {
  mixins: [getTableInfo],
  data() {
    return {
      seats: [],
      panInst: null,
      panId: null,
      pzx: null,
      pzy: null,
      mapSize: 800,
      selectedSeat: null,

      maxTop: 0,
      minTop: 10000000000,
      maxLeft: 0,
      minLeft: 1000000000,
      zoomScale: 1,
    };
  },
  mounted() {
    this.$store.dispatch('setCurrentStep', 1);
    setTimeout(() => {
      this.validateUserSeats();
    }, 1000);
  },
  filters: {
    getNumber: function(value) {
      if (!value) return '';
      value = value.toString();
      return value.split(';').pop();
    },
    getRow: function(value) {
      if (!value) return '';
      value = value.toString();
      return value.split(';').shift();
    },
  },
  computed: {
    ...mapGetters({
      sectorMap: 'sectorMap',
      selectedSector: 'selectedSector',
      cartProducts: 'cartProducts',
      removedSeat: 'removedSeat',
      canceledSeat: 'canceledSeat',
    }),
    activeDrawer() {
      return this.$store.getters.selectedSeat;
    },

    mapBgColor() {
      const bgColor = this.sectorMap.find(item => item.class === 'mapBgColor');
      if (bgColor) return bgColor.cor;
      else return '';
    },
    formattedMap() {
      return this.sectorMap;
    },
  },
  watch: {
    maxTop() {
      this.resetZoom();
    },

    maxLeft() {
      this.resetZoom();
    },
    canceledSeat() {
      if (this.canceledSeat) {
        let canceledElement = document.getElementById(
          this.canceledSeat.codigo_obj
        );
        canceledElement.classList.remove('selected-seat');
      }
    },
    cartProducts() {
      this.removedSeatFunction();
      let cartProd = [];

      this.cartProducts.forEach(product => {
        product
          .filter(cp => cp.haveSeat)
          .map(el => {
            el.codes.forEach(se => cartProd.push(se));
            return el.codigo_obj;
          });
      });

      if (cartProd.length) {
        cartProd.forEach(el => {
          let reservedSeat = this.sectorMap.filter(el => el.selecionado);
          if (reservedSeat.length) reservedSeat[0].selecionado = false;
          let cartSeat = document.getElementById(el);
          cartSeat.classList.add('reserved-seat');
        });
      }
    },
  },
  methods: {
    validateUserSeats() {
      let cartProd = [];

      this.cartProducts.forEach(product => {
        product
          .filter(cp => cp.haveSeat)
          .map(el => {
            el.codes.forEach(se => cartProd.push(se));
            return el.codigo_obj;
          });
      });

      if (cartProd.length) {
        cartProd.forEach(el => {
          let reservedSeat = this.sectorMap.filter(
            ca => parseInt(ca.codigo_obj) === parseInt(el)
          );
          reservedSeat[0].reserved = true;
          let cartSeat = document.getElementById(el);
          cartSeat.classList.add('reserved-seat');
        });
      }
    },
    checkIfWholeTable(seat) {
      return !(
        seat.class === 'cadeira' && String(seat.identificacao).includes('MESA')
      );
    },
    openInfo() {
      this.$store.commit('SET_SELECTED_INFO', true);
    },
    removedSeatFunction() {
      if (this.removedSeat) {
        let seatElement = document.getElementById(this.removedSeat.codigo_obj);
        seatElement.classList.remove('reserved-seat');
        seatElement.classList.remove('selected-seat');
      }
    },
    setSeatToSelect(el) {
      let code = el.target.id.includes('-')
        ? el.target.id.split('-')[0]
        : el.target.id;
      this.selectSeat(code);
    },

    handleShowError(el) {
      let code = el.target.id.includes('-')
        ? el.target.id.split('-')[0]
        : el.target.id;

      let seat = this.sectorMap.find(
        el => parseInt(el.codigo_obj) === parseInt(code)
      );

      if (
        !seat.disponivel &&
        seat.codigo_assento &&
        !this.$vuetify.breakpoint.mdAndUp
      ) {
        let namePerClass = '';

        if (seat.class === 'camarote') namePerClass = 'Camarote';
        else if (seat.class === 'cadeira') namePerClass = 'Assento';

        this.$store.dispatch('openSnackbar', {
          message: `${namePerClass} ${
            seat.class === 'cadeira'
              ? seat.identificacao.replace(';', '-')
              : this.getIdentification(seat)
          } Indisponível`,
          color: 'error',
          timeout: 3000,
        });
      }
    },

    onInit: function(panzoomInstance, id) {
      this.panId = id;
      this.panInst = panzoomInstance;
    },

    zoomUsingMidPoint() {
      const container = document.getElementById('panz');
      const [containerWidth, containerHeight] = [
        container.clientWidth,
        container.clientHeight,
      ];

      const midpoint = this.getMidpoint();
      if (midpoint) {
        const zoom = !this.$vuetify.breakpoint.mdAndUp ? 0.5 : 0.7;
        this.panInst.zoomAbs(containerWidth / 2, containerHeight / 2, zoom);
        this.panInst.moveTo(
          containerWidth / 2 - midpoint.x * zoom,
          ((-midpoint.y + 100) / 2) * zoom
        );
      }
    },

    getMidpoint() {
      const midpoint = this.sectorMap.find(item => item.class === 'midpoint');
      if (midpoint && midpoint.style) {
        const matchLeft = midpoint.style.match(/left:\s*([\d.]+)px/);
        const leftMidpoint = matchLeft ? parseInt(matchLeft[1]) : null;

        const matchTop = midpoint.style.match(/top:\s*([\d.]+)px/);
        const topMidpoint = matchTop ? parseInt(matchTop[1]) : null;

        if (leftMidpoint && topMidpoint) {
          return { x: leftMidpoint, y: topMidpoint };
        } else return null;
      } else {
        return null;
      }
    },

    resetZoom() {
      if (this.getMidpoint()) {
        this.zoomUsingMidPoint();
      } else {
        this.pzx = document.getElementById('panz').offsetWidth;
        this.pzy = document.getElementById('panz').offsetHeight;
        let mapSizeX = this.maxLeft - this.minLeft;
        let mapSizeY = this.maxTop - this.minTop;
        this.zoomScale = Math.min(
          this.pzx / (mapSizeX * 1.05),
          this.pzy / (mapSizeY * 1.05)
        );
        this.panInst.zoomAbs(this.pzx, this.pzy, this.zoomScale);
        this.panInst.moveTo(0, 0);
      }
    },
    onZoomIn() {
      let canvasx = document.getElementById('panz').offsetWidth;
      let canvasy = document.getElementById('panz').offsetHeight;
      this.panInst.smoothZoom(canvasx / 2, canvasy / 2, 1.5);
    },
    onZoomOut: function(panzoomInstance, id) {
      let canvasx = document.getElementById('panz').offsetWidth;
      let canvasy = document.getElementById('panz').offsetHeight;
      this.panInst.smoothZoom(canvasx / 2, canvasy / 2, 0.7);
    },
    selectSeat(codigo) {
      let seat = this.sectorMap.find(
        el => parseInt(el.codigo_obj) === parseInt(codigo)
      );

      if (seat.identificacao.includes('MESA') && seat.class === 'cadeira') {
        const table = this.formattedMap.find(
          test =>
            test.identificacao === seat.identificacao && test.class === 'mesa'
        );

        if (table) {
          seat = table;
          codigo = String(table.codigo_obj);
        }
      }

      if (
        seat &&
        seat.identificacao.includes('Mesa') &&
        !seat.identificacao.includes(';')
      ) {
        let haveSeatsInTable = this.sectorMap.find(el =>
          el.identificacao.includes(seat.identificacao + ';')
        );
        if (haveSeatsInTable) return;
      }

      this.$store.commit('SET_SELECTED_INFO', false);
      var getSeat = document.getElementById(codigo);
      getSeat.classList.toggle('selected-seat');

      if (
        this.selectedSeat &&
        this.selectedSeat[0].codigo_obj !== parseInt(codigo)
      ) {
        let prevSelectedSeat = document.getElementById(
          this.selectedSeat[0].codigo_obj
        );
        this.$store.commit('SET_SELECTED_SEAT', null);
        this.selectedSeat[0].selecionado = false;
        prevSelectedSeat.classList.remove('selected-seat');
      }

      if (!this.isSmAndDown && getSeat.classList.contains('selected-seat')) {
        this.selectedSeat = this.sectorMap.filter(
          el => parseInt(el.codigo_obj) === parseInt(codigo)
        );
        this.$store.commit('SET_SELECTED_SEAT', this.selectedSeat[0]);
        this.selectedSeat[0].selecionado = true;

        if (!this.activeDrawer) {
          this.panInst.moveTo(0, 0);
          this.panInst.zoomAbs(0, 0, 0.75);
          this.panInst.smoothZoom(getSeat.offsetLeft, getSeat.offsetTop, 2);
        }
      } else if (!this.isSmAndDown) {
        this.selectedSeat = this.sectorMap.filter(
          el => parseInt(el.codigo_obj) === parseInt(codigo)
        );
        this.selectedSeat[0].op = false;
        this.selectedSeat[0].selecionado = false;
        this.$store.commit('SET_SELECTED_SEAT', null);
        this.selectedSeat = null;
        this.panInst.moveTo(0, 0);
        this.panInst.zoomAbs(0, 0, 0.75);
        this.panInst.smoothZoom(getSeat.offsetLeft, getSeat.offsetTop, 2);
      } else if (
        this.isSmAndDown &&
        getSeat.classList.contains('selected-seat')
      ) {
        this.selectedSeat = this.sectorMap.filter(
          el => parseInt(el.codigo_obj) === parseInt(codigo)
        );
        this.selectedSeat[0].selecionado = true;
        this.$store.commit('SET_SELECTED_SEAT', this.selectedSeat[0]);
        this.$forceUpdate();
      } else if (this.isSmAndDown) {
        this.selectedSeat[0].selecionado = false;

        this.selectedSeat = null;
        this.$forceUpdate();
      }
    },
    checkObjectClass(value) {
      if (value.class === 'elementoIdent') return 'ident-bg';
      if (value.class === 'cadeiraObeso') return 'obeso';
      if (value.class === 'cadeiraDefici2' || value.class === 'cadeiraDefici1')
        return 'cadeirante';
      if (
        (value.tipo === '*' && !value.disponivel) ||
        (value.tipo === '9' && !value.produto_vinculado)
      )
        return 'dot disabled-seat';
      if (value.tipo === '*' || value.tipo === '9') return 'dot';
    },

    measureMap(style) {
      let styleArr = style.split(';');
      let top = parseInt(
        styleArr[0]
          .split(':')[1]
          .replace('px', '')
          .trim()
      );
      let left = parseInt(
        styleArr[1]
          .split(':')[1]
          .replace('px', '')
          .trim()
      );
      let width = styleArr.find(el => el.includes('width'))
        ? parseInt(
            styleArr
              .find(el => el.includes('width'))
              .split(':')[1]
              .replace('px', '')
              .trim()
          )
        : 0;
      let height = styleArr.find(el => el.includes('height'))
        ? parseInt(
            styleArr
              .find(el => el.includes('height'))
              .split(':')[1]
              .replace('px', '')
              .trim()
          )
        : 0;
      if (top > this.maxTop) this.maxTop = top + height / 2;
      if (left > this.maxLeft) this.maxLeft = left + width / 2;
      if (top < this.minTop) this.minTop = top - height / 2;
      if (left < this.minLeft) this.minLeft = left - width / 2;
    },

    validateStyle(value) {
      let style = value.style
        .replaceAll('#pst', 'position')
        .replaceAll('#abs', 'absolute')
        .replaceAll('#mr', 'margin-right')
        .replaceAll('#mt', 'margin-top')
        .replaceAll('#ml', 'margin-left')
        .replaceAll('#tt', 'text-transform')
        .replaceAll('#up', 'uppercase')
        .replaceAll('#fs', 'font-size')
        .replaceAll('#bc', 'background-color')
        .replaceAll('#lh', 'line-height')
        .replaceAll('#ls', 'letter-spacing');

      this.measureMap(style);

      let seat = this.sectorMap.find(
        el => parseInt(el.codigo_obj) === parseInt(value.codigo_obj)
      );
      if (
        seat &&
        seat.identificacao.includes('Mesa') &&
        !seat.identificacao.includes(';')
      ) {
        let haveSeatsInTable = this.sectorMap.find(el =>
          el.identificacao.includes(seat.identificacao + ';')
        );
        if (haveSeatsInTable) style += ' cursor: default;';
      }

      if (value.tipo !== '*' && value.tipo !== '9') return style;

      if (
        (value.tipo === '*' && !value.disponivel) ||
        (value.tipo === '9' && (!value.produto_vinculado || !value.disponivel))
      ) {
        style += ' background-color: #B0B6BF;';
      } else if (value.cor && value.disponivel) {
        style += ` background-color: ${value.cor};"`;
      } else style += ' background-color: #1976d2;';

      return style;
    },
    getStyleCircle(index, length, size, topStyle, leftStyle) {
      let div = 360 / length;
      let radius = size / 2;
      let top = Math.sin(div * index * (Math.PI / 180)) * (size / 1.5);
      let left = Math.cos(div * index * (Math.PI / 180)) * (size / 1.5);
      return `left: ${left + leftStyle + radius - 10}px; top: ${top +
        topStyle +
        radius -
        10}px;`;
    },

    rangeByType(productTypes) {
      let min = Number.MAX_SAFE_INTEGER;
      let max = Number.MIN_SAFE_INTEGER;

      productTypes.forEach(type => {
        if (!type.encerrado) {
          const value = type.valor + type.valor_conveniencia;
          if (min > value) {
            min = value;
          }

          if (max < value) {
            max = value;
          }
        }
      });

      if (max === Number.MIN_SAFE_INTEGER && min === Number.MAX_SAFE_INTEGER) {
        max = 0;
        min = 0;
        return '';
      }
      min = this.$options.filters.currency(min * 100);
      max = this.$options.filters.currency(max * 100);
      return min !== max ? `De ${min} a ${max}` : `${min}`;
    },

    showPriceRange(seat) {
      return this.rangeByType(
        this.selectedSector.products.filter(
          t => seat.produto_vinculado === t.codigo_produto
        )
      );
    },

    getProductDetails(seat) {
      let findedProduct = this.selectedSector.products.find(
        t => seat.produto_vinculado === t.codigo_produto
      );

      if (findedProduct) return findedProduct;
      else return '';
    },

    getIdentification(seat) {
      const { identificacao } = seat;

      let stringIdentification = String(identificacao);

      if (
        identificacao.toLowerCase().includes('mesa') &&
        seat.class === 'mesa'
      ) {
        return this.MIXIN_AUX_getTableLineUpLabel(stringIdentification);
      }

      let formatted = stringIdentification.replace('Mesa', '');

      if (stringIdentification.includes('Mesa')) {
        if (seat.class === 'cadeira') return formatted.split(';').pop();
        else return formatted;
      } else if (stringIdentification.includes('MESA')) {
        if (seat.class === 'cadeira') return '';
        else return formatted.split('-')[1];
      }

      return this.getNumberMethod(stringIdentification);
    },
    getNumberMethod(value) {
      if (!value) return '';
      value = value.toString();
      return value.split(';').pop();
    },
    getSpecificStyle(style, type) {
      let splittedStyle = style.split('; ');
      let specificStyle = null;
      splittedStyle.forEach(s => {
        if (s.includes(type) && !specificStyle) specificStyle = s.split(' ')[1];
      });
      return String(specificStyle).replace(';', '');
    },

    checkIfIsRectangularTable(table) {
      const widthMatch = table.style.match(/width:\s*(\d+)px/);
      const heightMatch = table.style.match(/height:\s*(\d+)px/);

      const width = widthMatch ? parseInt(widthMatch[1]) : null;
      const height = heightMatch ? parseInt(heightMatch[1]) : null;

      return width !== null && height !== null && width !== height;
    },
  },
};
</script>

<style scoped>
#seatmap {
  width: 150vw;
  height: 100vh;
  position: relative;
  overflow: visible;
}
.seat-header {
  height: 60px;
}
.dot {
  cursor: pointer;
  height: 20px;
  width: 20px;
  border-radius: 50%;
  display: inline-block;
}
.cadeirante {
  cursor: pointer;
  height: 20px;
  width: 43px;
  margin: 0px 5px;
  background-color: #1976d2;
  border-radius: 4px;
  display: inline-block;
}
.obeso {
  cursor: pointer;
  height: 20px;
  width: 27px;
  background-color: #1976d2;
  border-radius: 3px;
  display: inline-block;
}
.selected-seat {
  background-color: #10e79f !important;
}
.seat-number {
  color: white;
  font-size: 9px;
}
.seat-cadeirante {
  color: white;
  font-size: 18px;
}
.selected-seat .seat-cadeirante {
  color: #192b46 !important;
}
.selected-seat .seat-number {
  color: #192b46 !important;
}
.identificacao {
  display: inline-block;
  background-color: #f1f2f3 !important;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) scale(1);
  -webkit-transform: translate(-50%, -50%) scale(1);
  font-weight: bold;
  font-size: 12px;
  line-height: 23px;
  letter-spacing: 0.25px;
  color: #626973;
  white-space: nowrap !important;
}
.ident-bg {
  background-color: #f1f2f3 !important;
}
.palco {
  font-size: 20px;
  line-height: 23px;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}
.noselect {
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Old versions of Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none; /* Non-prefixed version, currently
                                  supported by Chrome, Opera and Firefox */
}
.tooltip-text-title {
  color: white;
  font-weight: 900;
  font-size: 18px;
}
.tooltip-text {
  color: white;
  font-size: 14px;
  font-weight: 450;
  line-height: 20px;
}
.add-remove-button {
  height: 24px !important;
  width: 24px !important;
  margin: 0;
  border-width: 2px !important;
  justify-content: center;
}

.add-remove-button__icon {
  font-size: 19px !important;
  font-weight: bold;
}
.seat-header-text {
  font-size: 14px;
  line-height: 18px;
  font-weight: 450;
  font-style: normal;
  align-items: center;
  color: #838d9b;
  vertical-align: middle;
}
.seat-header-text-mb {
  font-size: 10px;
  line-height: 18px;
  font-weight: 450;
  font-style: normal;
  align-items: center;
  color: #838d9b;
  vertical-align: middle;
}
.seat-header-subtitle-text {
  font-size: 14px;
  line-height: 18px;
  font-weight: 450;
  font-style: normal;
  align-items: center;
  color: #1976d2;
  vertical-align: middle;
}
.recenter-btn {
  width: 23px !important;
  height: 23px !important;
}
.selecting {
  pointer-events: none;
}
.disabled-seat {
  cursor: move;
}

.reserved-seat {
  background-color: #10e79f !important;
}
.reserved-seat .seat-number {
  color: #192b46 !important;
}
.reserved-seat .theme--light.v-icon {
  color: #192b46 !important;
}
.click-btn {
  cursor: pointer;
}
</style>

<style>
.ident-palco p {
  color: white !important;
  margin-bottom: 0px !important;
  font-size: 12px !important;
  font-weight: bold;
}
</style>
